import { Component, OnInit } from '@angular/core';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';
import { FilterChangedEvent, IFloatingFilterParams } from 'ag-grid-community';

@Component({
    selector: 'app-refresh',
    template: `<img (click)="reload()" src="assets/images/refresh.svg" style="cursor:pointer;">`,
    standalone: false // NOSONAR
})
export class RefreshComponent implements IFloatingFilterAngularComp {
  private params!: IFloatingFilterParams;

  constructor() {}
  onParentModelChanged(_parentModel: any, _filterChangedEvent?: FilterChangedEvent<any, any>): void {
    // do nothing 
  }
  afterGuiAttached?(): void {
    console.info('something')
  }

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  reload(){
    this.params.api.setFilterModel(null);
  }


}
